import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { Table } from "react-bootstrap";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import Pagination from "../../../components/Pagination";

const EmployeeComponent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Component"));
  }, []);

  const [employeeData, setEmployeeData] = useState({});
  const [listEmployee, setListEmployee] = useState([]);
  const [scaleList, setScaleList] = useState([]);
  const [selectedScale, setselectedScale] = useState({
    value: 1,
    label: "Current Scale",
  });
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);


  // Helper function to check if a column is a date field
  const isDateField = (column) => {
    return column === "FromDate";
  };

  // Helper function to format date
  const formatDate = (dateValue) => {
 if (!dateValue) return "-";
  
  try {
    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
  } catch (e) {
    return dateValue;
  }
  
  return dateValue;
  };

  const fetchEmployeeData = async (scale, emp) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/9?P_EmployeeID=${emp || 0}&P_AsOnDate=${scale || 0
        }`
      );
      const data = response?.data?.data?.data;
      setEmployeeData(data);

      const scaleData = response?.data?.data?.scale;
      const ScaleOpt = Object.entries(scaleData).map(([key, value]) => ({
        value: key,
        label: value,
      }));
      setScaleList(ScaleOpt);
      if (ScaleOpt.length > 0 && !selectedScale) {
        setselectedScale(ScaleOpt[0]);
      }

      const EmployeeList = response?.data?.data?.empList.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setListEmployee(EmployeeList);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    fetchEmployeeData();
  }, []);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };
  const filteredData = Object.entries(employeeData || {});
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);
  const handleGetDataClick = () => {
    if (selectedScale || selectedEmp) {
      fetchEmployeeData(selectedScale?.value, selectedEmp?.value);
    }
  };
  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <div className="col-md-2">
              <div className="mb-3">
                <label for="Code" className="form-label">
                  Scale
                </label>
                <Select
                  options={scaleList}
                  value={selectedScale}
                  onChange={setselectedScale}
                />
              </div>
            </div>

            <div className="col-md-2">
              <div className="mb-3">
                <label for="Code" className="form-label">
                  Employee
                </label>
                <Select
                  options={listEmployee}
                  value={selectedEmp}
                  onChange={setSelectedEmp}
                />
              </div>
            </div>

            <div className="col-md-2">
              <div style={{ marginTop: "33px" }}>
                <button className="custom-btn" onClick={handleGetDataClick}>
                  Get Data
                </button>
              </div>
            </div>
          </div>
          <div className="row p-2" style={{ overflowX: "auto" }}>
            <div className="table-responsive">
              <Table striped bordered hover rounded>
                <thead id="thcolor">
                  <tr>
                    <td rowSpan="2">
                      <div className="text-end">Payroll</div>
                      <div className="border-top">Employee</div>
                    </td>
                    {[
                      "Effective Date", "Basic", "HRA", "Professional Development Allowance", "Conv Allow", "Leave Travel Allowance", 
                      "Gross Salary",
                      "PT", "Provident Fund", "PFDIR1", "Net Salary",
                      "Other Allowance", "NPS", "NPS Deduction", "Other Deduction", 
                      "Voluntary Provident Fund"
                    ]
                      .map((column, idx) => (
                        <td key={idx} className="text-center">
                          {column}
                        </td>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length > 0 ? (
                    <>
                      {currentData.map(([employeeName, details], index) => (
                        <tr key={index}>
                          <td
                            style={{
                              backgroundColor: "#2E2E48",
                              color: "#ffffff",
                            }}
                          >
                            {employeeName}
                          </td>
                          {[
                            "FromDate", "Basic", "HRA", "Professional Development Allowance", "Conv Allow","Leave Travel Allowance",  "Gross Salary",
                            "PT", "Provident Fund", "PFDIR1", "Net Salary",
                            "Other Allowance", "NPS", "NPS Deduction", "Other Deduction", "Voluntary Provident Fund"
                          ].map((column, idx) => (
                            <td key={idx} className={isDateField(column) ? "text-center" : "text-end"}>
                              {isDateField(column) ? (
                                formatDate(details[column])
                              ) : (
                                new Intl.NumberFormat("en-IN", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(details[column] || 0)
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}

                      {/* Total Row */}
                      <tr>
                        <td
                          className="text-end"
                          style={{ backgroundColor: "#2E2E48", color: "#ffffff" }}
                        >
                          <strong>Total</strong>
                        </td>
                        {[
                          "",
                          "Basic",
                          "HRA",
                          "Professional Development Allowance",
                          "Conv Allow",
                          "Leave Travel Allowance",
                          "Gross Salary",
                          "PT",
                          "Provident Fund",
                          "PFDIR1",
                          "Net Salary",
                          "NPS",
                          "NPS Deduction",
                          "Other Allowance",
                          "Other Deduction",
                          "Voluntary Provident Fund",
                        ].map((column, idx) => (
                          <td key={idx} className="text-end">
                            <strong>
                              {new Intl.NumberFormat("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                filteredData.reduce(
                                  (sum, [, details]) =>
                                    sum + parseFloat(details[column] || 0),
                                  0
                                )
                              )}
                            </strong>
                          </td>
                        ))}
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="14" className="text-center">
                        No record found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <span className="d-flex">
                  Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
                  {Math.min(
                    currentPage * selectedRecordsPerPage,
                    filteredData.length
                  )}{" "}
                  of {filteredData.length} <span className="ms-1">results</span>
                  <select
                    value={selectedRecordsPerPage}
                    onChange={handleRecordsPerPage}
                    className="mx-2 form-select-sm"
                  >
                    {recordsPerPageOption.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div>
                <Pagination
                  itemsPerPage={itemsPerPage}
                  totalItems={filteredData.length}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeComponent;
